import { useMutation, useQueryClient } from 'react-query';

import api from '@shared/api';

async function setDefaultModelView({
  modelId,
  viewId
}: {
  modelId: string;
  viewId: string;
}) {
  await api.put<{ id: string }>(`mpm/models/${modelId}/views/default`, {
    id: viewId
  });
}

export function useModelViewSetDefaultMutation() {
  const queryClient = useQueryClient();
  return useMutation(
    ({ modelId, viewId }: { modelId: string; viewId: string }) => {
      return setDefaultModelView({ modelId, viewId });
    },
    {
      onSuccess: (_, { modelId }) => {
        queryClient.invalidateQueries(['model-summary-views', { modelId }]);
      }
    }
  );
}
